import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Do you only work with holiday parks?",
    a: "No. While Robust Entertainment has a strong background in holiday centres and leisure venues, we can also support theatres, attractions, resorts, events, family venues and entertainment-led businesses.",
  },
  {
    q: "Can you provide a complete entertainment package?",
    a: "Yes. This is one of our biggest strengths. We can provide creative development, production shows, cabaret acts, visual content, team training, technical installations and ongoing support.",
  },
  {
    q: "Do you create original characters?",
    a: "Yes. We develop character brands from concept to delivery, including design direction, branding, costume ideas, storytelling, animation, production use and guest experience.",
  },
  {
    q: "Can you supply tribute acts and cabaret performers?",
    a: "Yes. We can supply cabaret acts, including some of the UK's finest tribute acts, as part of a wider entertainment programme or as standalone bookings.",
  },
  {
    q: "Do you offer technical installations?",
    a: "Yes. We provide sound, lighting and LED screen installations, using high-quality products, efficient installation teams and ongoing backup.",
  },
  {
    q: "Do you train entertainment teams?",
    a: "Yes. We provide training to help entertainment teams improve confidence, professionalism, audience engagement, daytime delivery, character work and main stage performance.",
  },
  {
    q: "Can you create visual content for screens?",
    a: "Yes. We create screen visuals, motion graphics, animation, promotional videos, event visuals, digital advertising assets and branded media.",
  },
  {
    q: "How do we get started?",
    a: "The first step is to book a discovery call. We will discuss your venue, goals, current entertainment setup and the best way Robust Entertainment can support you.",
  },
];

export const FAQ = () => {
  return (
    <section id="faqs" className="relative py-14 lg:py-20 bg-[#0D0D0D] border-y border-[#D4AF37]/25">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <p className="text-sm sm:text-base font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-4 text-center">FAQs</p>
        <h2 className="font-heading heading-fluid font-medium tracking-normal text-metal text-center mb-10">
          Frequently Asked Questions
        </h2>
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-[#121212] border border-white/10 rounded-xl px-6 data-[state=open]:border-[#D4AF37]/50"
            >
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-white hover:no-underline hover:text-[#D4AF37] font-medium py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-zinc-300 leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
